/*
 * ms-bloques — la parte viva de la promo por bloques (Dyski Dupes, 28-sep-2026).
 *  1. Selector de decants de regalo (desde el carrito o desde la página «Arma tu pack»).
 *  2. Retiro automático de los decants que no se ganaron (N por cada bloque; un pack cuenta como bloque).
 *  3. <ms-arma-pack>: elegir N piezas + sus decants y mandarlos juntos al carrito.
 * No calcula precios: el descuento lo cobra la app; aquí solo se cuenta y se agrega.
 * La configuración llega en data-ms-bloques del <script> (snippets/ms-bloques-script.liquid).
 */
(function () {
  if (window.__msBloques) return;

  var tag = document.currentScript;
  var CFG = {};
  try {
    CFG = JSON.parse((tag && tag.getAttribute('data-ms-bloques')) || '{}');
  } catch (e) {
    CFG = {};
  }
  CFG.piezas = Number(CFG.piezas) || 4;
  CFG.decantsPorBloque = Number(CFG.decantsPorBloque) || 0;
  window.__msBloques = { cfg: CFG };

  /* ---------- rutas y utilidades ---------- */
  function rutaJs(raw, def) {
    var url = String(raw || def).trim();
    return url.indexOf('.js') > -1 ? url : url.replace(/\/?$/, '') + '.js';
  }
  var T = window.Theme && window.Theme.routes ? window.Theme.routes : {};
  var RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (RAIZ.slice(-1) !== '/') RAIZ += '/';
  var URL_CART = RAIZ + 'cart.js';
  var URL_ADD = rutaJs(T.cart_add_url, '/cart/add.js');
  var URL_CHANGE = rutaJs(T.cart_change_url, '/cart/change.js');
  var URL_UPDATE = rutaJs(T.cart_update_url, '/cart/update.js');

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function dinero(n) {
    var v = Number(n) || 0;
    var s = v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + s.replace(/\.00$/, '');
  }
  function img(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300);
  }
  function partir(titulo) {
    // «Decant 10 ml — Obsidian Code – Inspirado en Sauvage» → nombre «Obsidian Code», inspirado «Sauvage»
    var limpio = String(titulo || '').replace(/^\s*decant\s+[\d.,]+\s*ml\s*[–—-]\s*/i, '');
    var m = limpio.split(/\s*[–—-]\s*Inspirado en\s*/i);
    return { nombre: m[0], inspirado: (m[1] || '').replace(/\s*-\s*100\s*ml\s*$/i, '') };
  }
  function genero(p) {
    var t = (p.tags || []).map(function (x) { return String(x).toLowerCase(); });
    for (var i = 0; i < t.length; i++) {
      var g = t[i].split('|')[0].trim();
      if (g === 'mujer' || g === 'hombre' || g === 'unisex') return g;
    }
    return '';
  }
  async function json(url, opts) {
    var r = await fetch(url, opts);
    var txt = await r.text();
    if (txt.trim().charAt(0) === '<') return null;
    try { return JSON.parse(txt); } catch (e) { return null; }
  }
  function post(url, body) {
    return json(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  /* Un regalo se ofrece solo si está disponible y cuesta $0 (CFG.prueba = colección de prueba, cualquier precio). */
  function regaloValido(p) {
    var v = p.variants && p.variants[0];
    return !!v && v.available && (CFG.prueba || Number(v.price) === 0);
  }

  var cacheCol = {};
  function productos(handle) {
    if (!handle) return Promise.resolve([]);
    if (!cacheCol[handle]) {
      cacheCol[handle] = json(RAIZ + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250').then(function (d) {
        return (d && d.products) || [];
      });
    }
    return cacheCol[handle];
  }

  /* Avisa al tema: el cajón se vuelve a dibujar solo (CartItemsComponent escucha cart:update). */
  function refrescar(cart, abrir) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'ms-bloques',
          data: { source: 'ms-bloques', itemCount: cart ? cart.item_count : 0, deferDrawerOpen: !abrir },
        },
      })
    );
    if (abrir) {
      var d = document.querySelector('cart-drawer-component');
      if (d && typeof d.open === 'function') d.open();
    }
  }

  /* ---------- la cuenta de derechos ---------- */
  async function cuenta(cart) {
    var listas = await Promise.all([productos(CFG.decants), productos(CFG.packs)]);
    var decIds = new Set(listas[0].map(function (p) { return p.id; }));
    var packIds = new Set(listas[1].map(function (p) { return p.id; }));
    var r = { sueltos: 0, packs: 0, decants: 0, lineasDec: [], porVariante: {} };
    (cart.items || []).forEach(function (it) {
      if (decIds.has(it.product_id)) {
        r.decants += it.quantity;
        r.lineasDec.push(it);
        r.porVariante[it.variant_id] = it;
      } else if (packIds.has(it.product_id)) {
        r.packs += it.quantity;
      } else if (it.product_type === CFG.tipo) {
        r.sueltos += it.quantity;
      }
    });
    r.derecho = Math.floor((r.sueltos + r.packs * CFG.piezas) / CFG.piezas) * CFG.decantsPorBloque;
    return r;
  }

  /* ---------- retiro de los decants que no se ganaron ---------- */
  var ajustando = false;
  async function ajustar() {
    if (ajustando || !CFG.decants) return;
    ajustando = true;
    try {
      var cart = await json(URL_CART);
      if (!cart) return;
      var c = await cuenta(cart);
      var sobran = c.decants - c.derecho;
      if (sobran <= 0) return;
      var updates = {};
      // El carrito lista primero lo último que se agregó: se quita eso primero.
      for (var i = 0; i < c.lineasDec.length && sobran > 0; i++) {
        var it = c.lineasDec[i];
        var quita = Math.min(it.quantity, sobran);
        updates[it.key] = it.quantity - quita;
        sobran -= quita;
      }
      var nuevo = await post(URL_UPDATE, { updates: updates });
      refrescar(nuevo, false);
    } catch (e) {
      console.warn('[ms-bloques] ajustar', e);
    } finally {
      ajustando = false;
    }
  }
  var espera;
  document.addEventListener('cart:update', function (ev) {
    var src = ev && ev.detail && ev.detail.data && ev.detail.data.source;
    if (src === 'ms-bloques') {
      if (selector.abierto && selector.modo === 'carrito') selector.sincronizar();
      return;
    }
    clearTimeout(espera);
    espera = setTimeout(ajustar, 450);
  });

  /* ---------- selector de decants ---------- */
  var selector = {
    dialogo: null,
    abierto: false,
    modo: 'carrito',
    derecho: 0,
    elegidos: {},
    filtro: '',
    lista: [],
    alCambiar: null,

    crear: function () {
      if (this.dialogo) return this.dialogo;
      var d = document.createElement('dialog');
      d.className = 'ms-blq-sel';
      d.setAttribute('aria-labelledby', 'ms-blq-sel-titulo');
      d.style.setProperty('--ms-blq-fondo', CFG.fondo || '#0A0A0A');
      d.style.setProperty('--ms-blq-acento', CFG.acento || '#E3E38F');
      d.style.setProperty('--ms-blq-superficie', CFG.superficie || '#F4F4F0');
      d.innerHTML =
        '<div class="ms-blq-sel__caja">' +
        '<div class="ms-blq-sel__cabeza">' +
        '<h2 class="ms-blq-sel__titulo" id="ms-blq-sel-titulo">Elige tus decants de regalo</h2>' +
        '<button type="button" class="ms-blq-sel__cerrar" data-cerrar aria-label="Cerrar">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
        '</button></div>' +
        '<div class="ms-blq-sel__cuenta"><span class="ms-blq-sel__cuenta-t" data-cuenta-t></span><strong class="ms-blq-sel__cuenta-n" data-cuenta-n></strong></div>' +
        '<div class="ms-blq-sel__chips" data-chips></div>' +
        '<div class="ms-blq-sel__grid" data-grid role="list"></div>' +
        '<div class="ms-blq-sel__pie"><button type="button" class="ms-blq-sel__listo" data-cerrar></button></div>' +
        '</div>';
      document.body.appendChild(d);
      var self = this;
      d.addEventListener('click', function (ev) {
        if (ev.target === d || ev.target.closest('[data-cerrar]')) {
          self.cerrar();
          return;
        }
        var chip = ev.target.closest('[data-filtro]');
        if (chip) {
          self.filtro = chip.getAttribute('data-filtro');
          self.pintar();
          return;
        }
        var b = ev.target.closest('[data-variante]');
        if (b && !b.disabled) self.alternar(Number(b.getAttribute('data-variante')), b);
      });
      d.addEventListener('close', function () {
        self.abierto = false;
      });
      this.dialogo = d;
      return d;
    },

    abrir: async function (opciones) {
      this.crear();
      this.modo = opciones.modo || 'carrito';
      this.derecho = opciones.derecho || 0;
      this.elegidos = opciones.elegidos || {};
      this.alCambiar = opciones.alCambiar || null;
      this.filtro = '';
      this.lista = (await productos(CFG.decants)).filter(regaloValido);
      if (this.modo === 'carrito') await this.sincronizar(true);
      this.pintar();
      if (!this.dialogo.open) this.dialogo.showModal();
      this.abierto = true;
    },

    cerrar: function () {
      if (this.dialogo && this.dialogo.open) this.dialogo.close();
      this.abierto = false;
    },

    sincronizar: async function (sinPintar) {
      var cart = await json(URL_CART);
      if (!cart) return;
      var c = await cuenta(cart);
      this.derecho = c.derecho;
      var e = {};
      c.lineasDec.forEach(function (it) {
        e[it.variant_id] = (e[it.variant_id] || 0) + it.quantity;
      });
      this.elegidos = e;
      this.lineas = c.porVariante;
      if (!sinPintar) this.pintar();
    },

    total: function () {
      var n = 0;
      for (var k in this.elegidos) n += this.elegidos[k];
      return n;
    },

    alternar: async function (variante, boton) {
      var ya = this.elegidos[variante] > 0;
      if (!ya && this.total() >= this.derecho) return;
      if (this.modo === 'local') {
        if (ya) delete this.elegidos[variante];
        else this.elegidos[variante] = 1;
        this.pintar();
        if (this.alCambiar) this.alCambiar(this.elegidos);
        return;
      }
      boton.disabled = true;
      boton.setAttribute('aria-busy', 'true');
      try {
        var cart;
        if (ya) {
          var linea = this.lineas && this.lineas[variante];
          cart = await post(URL_CHANGE, { id: linea ? linea.key : String(variante), quantity: 0 });
        } else {
          await post(URL_ADD, { items: [{ id: variante, quantity: 1 }] });
          cart = await json(URL_CART);
        }
        await this.sincronizar();
        refrescar(cart, false);
      } catch (e) {
        console.warn('[ms-bloques] decant', e);
      }
    },

    pintar: function () {
      var d = this.dialogo;
      if (!d) return;
      var self = this;
      var total = this.total();
      var faltan = Math.max(0, this.derecho - total);
      d.querySelector('[data-cuenta-t]').textContent =
        this.derecho + ' de regalo' + (CFG.ml ? ' · ' + CFG.ml + ' c/u' : '');
      d.querySelector('[data-cuenta-n]').textContent = total + ' de ' + this.derecho;

      var generos = {};
      this.lista.forEach(function (p) {
        var g = genero(p);
        if (g) generos[g] = true;
      });
      var etiquetas = { mujer: 'Para ella', hombre: 'Para él', unisex: 'Unisex' };
      var chips = Object.keys(generos);
      d.querySelector('[data-chips]').innerHTML = chips.length
        ? ['']
            .concat(chips)
            .map(function (g) {
              return (
                '<button type="button" class="ms-blq-sel__chip" data-filtro="' + g + '" aria-pressed="' +
                (self.filtro === g) + '">' + (g ? etiquetas[g] || g : 'Todos') + '</button>'
              );
            })
            .join('')
        : '';

      var lista = this.lista.filter(function (p) {
        return !self.filtro || genero(p) === self.filtro;
      });
      d.querySelector('[data-grid]').innerHTML = lista.length
        ? lista
            .map(function (p) {
              var v = p.variants[0];
              var t = partir(p.title);
              var ya = self.elegidos[v.id] > 0;
              var bloqueado = !ya && total >= self.derecho;
              var foto = p.images && p.images[0] ? img(p.images[0].src, 300) : '';
              return (
                '<div class="ms-blq-sel__card" role="listitem">' +
                '<div class="ms-blq-sel__foto">' +
                (foto ? '<img src="' + esc(foto) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
                (CFG.ml ? '<span class="ms-blq-sel__ml">' + esc(CFG.ml) + '</span>' : '') +
                '</div>' +
                '<span class="ms-blq-sel__nombre">' + esc(t.nombre) + '</span>' +
                (t.inspirado ? '<span class="ms-blq-sel__insp">' + esc(t.inspirado) + '</span>' : '') +
                '<button type="button" class="ms-blq-sel__btn' + (ya ? ' is-elegido' : '') + '" data-variante="' + v.id +
                '" aria-pressed="' + ya + '"' + (bloqueado ? ' disabled' : '') + '>' +
                (ya ? 'Elegido' : 'Agregar') + '</button>' +
                '</div>'
              );
            })
            .join('')
        : '<p class="ms-blq-sel__vacio">Todavía no hay decants disponibles.</p>';

      var listo = d.querySelector('.ms-blq-sel__listo');
      listo.textContent = faltan > 0 ? 'Listo · faltan ' + faltan : 'Listo';
    },
  };

  document.addEventListener('click', function (ev) {
    var abrir = ev.target.closest('[data-ms-abrir-decants]');
    if (abrir) {
      ev.preventDefault();
      selector.abrir({ modo: 'carrito' });
      return;
    }
    var quitar = ev.target.closest('[data-ms-quitar-decant]');
    if (quitar) {
      ev.preventDefault();
      quitar.disabled = true;
      post(URL_CHANGE, { id: quitar.getAttribute('data-key'), quantity: Number(quitar.getAttribute('data-qty')) || 0 }).then(function (cart) {
        refrescar(cart, false);
      });
    }
  });

  /* ---------- armador «Arma tu pack» ---------- */
  if (!customElements.get('ms-arma-pack')) {
    customElements.define(
      'ms-arma-pack',
      class extends HTMLElement {
        connectedCallback() {
          if (this._listo) return;
          this._listo = true;
          this.piezas = Number(this.dataset.piezas) || CFG.piezas;
          this.decantsX = Number(this.dataset.decants) || CFG.decantsPorBloque;
          this.colPiezas = this.dataset.coleccion;
          this.colDecants = this.dataset.decantsCol || CFG.decants;
          this.elegidas = {};
          this.decants = {};
          this.filtro = '';
          this.busqueda = '';
          this.addEventListener('click', this.onClick.bind(this));
          var buscar = this.querySelector('[data-buscar]');
          if (buscar) {
            var self = this;
            buscar.addEventListener('input', function () {
              self.busqueda = buscar.value.trim().toLowerCase();
              self.pintarPiezas();
            });
          }
          this.cargar();
        }

        async cargar() {
          var listas = await Promise.all([productos(this.colPiezas), productos(this.colDecants)]);
          this.lista = listas[0].filter(function (p) { return p.variants && p.variants[0]; });
          this.listaDec = listas[1].filter(regaloValido);
          var pasoDec = this.querySelector('[data-paso-decants]');
          var sinDec = !this.listaDec.length || !this.decantsX;
          if (pasoDec) pasoDec.hidden = sinDec;
          var infoDec = this.querySelector('[data-paso-decants-info]');
          if (infoDec) infoDec.hidden = sinDec;
          this.pintarChips();
          this.pintarPiezas();
          this.pintarDecants();
          this.pintarBarra();
        }

        totalPiezas() {
          var n = 0;
          for (var k in this.elegidas) n += this.elegidas[k];
          return n;
        }
        totalDecants() {
          var n = 0;
          for (var k in this.decants) n += this.decants[k];
          return n;
        }

        pintarChips() {
          var cont = this.querySelector('[data-chips]');
          if (!cont) return;
          var g = {};
          this.lista.forEach(function (p) {
            var x = genero(p);
            if (x) g[x] = true;
          });
          var etiquetas = { mujer: 'Para ella', hombre: 'Para él', unisex: 'Unisex' };
          var self = this;
          var keys = Object.keys(g);
          cont.innerHTML = keys.length
            ? [''].concat(keys).map(function (x) {
                return '<button type="button" class="ms-arma__chip" data-filtro="' + x + '" aria-pressed="' + (self.filtro === x) + '">' +
                  (x ? etiquetas[x] || x : 'Todos') + '</button>';
              }).join('')
            : '';
        }

        pintarPiezas() {
          var cont = this.querySelector('[data-grid-piezas]');
          if (!cont) return;
          var self = this;
          var lleno = this.totalPiezas() >= this.piezas;
          var lista = this.lista.filter(function (p) {
            if (self.filtro && genero(p) !== self.filtro) return false;
            if (self.busqueda && (p.title + ' ' + (p.tags || []).join(' ')).toLowerCase().indexOf(self.busqueda) === -1) return false;
            return true;
          });
          cont.innerHTML = lista.length
            ? lista.map(function (p) {
                var v = p.variants[0];
                var t = partir(p.title);
                var n = self.elegidas[v.id] || 0;
                var agotado = !v.available;
                var foto = p.images && p.images[0] ? img(p.images[0].src, 400) : '';
                var control = agotado
                  ? '<span class="ms-arma__agotado">Agotado</span>'
                  : n > 0
                  ? '<div class="ms-arma__stepper"><button type="button" data-menos="' + v.id + '" aria-label="Quitar uno de ' + esc(t.nombre) +
                    '">−</button><span aria-live="polite">' + n + '</span><button type="button" data-mas="' + v.id + '" aria-label="Agregar otro ' +
                    esc(t.nombre) + '"' + (lleno ? ' disabled' : '') + '>+</button></div>'
                  : '<button type="button" class="ms-arma__agregar" data-mas="' + v.id + '"' + (lleno ? ' disabled' : '') + '>Agregar</button>';
                return (
                  '<div class="ms-arma__card' + (n > 0 ? ' is-elegida' : '') + '" role="listitem">' +
                  '<div class="ms-arma__foto">' + (foto ? '<img src="' + esc(foto) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
                  '<span class="ms-arma__nombre">' + esc(t.nombre) + '</span>' +
                  (t.inspirado ? '<span class="ms-arma__insp">Inspirado en ' + esc(t.inspirado) + '</span>' : '') +
                  '<span class="ms-arma__precio">' + dinero(v.price) + '</span>' +
                  control +
                  '</div>'
                );
              }).join('')
            : '<p class="ms-arma__vacio">No encontramos ese aroma.</p>';
        }

        pintarDecants() {
          var cont = this.querySelector('[data-grid-decants]');
          if (!cont || !this.listaDec) return;
          var self = this;
          var abierto = this.totalPiezas() >= this.piezas;
          var total = this.totalDecants();
          var paso = this.querySelector('[data-paso-decants]');
          if (paso) paso.classList.toggle('is-bloqueado', !abierto);
          cont.innerHTML = this.listaDec.map(function (p) {
            var v = p.variants[0];
            var t = partir(p.title);
            var ya = self.decants[v.id] > 0;
            var bloq = !abierto || (!ya && total >= self.decantsX);
            var foto = p.images && p.images[0] ? img(p.images[0].src, 300) : '';
            return (
              '<div class="ms-arma__card ms-arma__card--dec' + (ya ? ' is-elegida' : '') + '" role="listitem">' +
              '<div class="ms-arma__foto">' + (foto ? '<img src="' + esc(foto) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
              '<span class="ms-arma__nombre">' + esc(t.nombre) + '</span>' +
              '<button type="button" class="ms-arma__agregar' + (ya ? ' is-elegido' : '') + '" data-decant="' + v.id + '" aria-pressed="' + ya + '"' +
              (bloq ? ' disabled' : '') + '>' + (ya ? 'Elegido' : 'Agregar') + '</button>' +
              '</div>'
            );
          }).join('');
        }

        pintarBarra() {
          var n = this.totalPiezas();
          var d = this.totalDecants();
          var set = function (sel, txt) {
            this.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
          }.bind(this);
          set('[data-cuenta-piezas]', n + ' de ' + this.piezas);
          set('[data-cuenta-decants]', d + ' de ' + this.decantsX);
          var barra = this.querySelector('[data-barra]');
          if (barra) barra.style.setProperty('--ms-arma-avance', Math.min(100, (n / this.piezas) * 100) + '%');
          var btn = this.querySelector('[data-agregar-pack]');
          if (btn) {
            btn.disabled = n < this.piezas;
            var falta = this.piezas - n;
            btn.textContent = n < this.piezas
              ? 'Elige ' + falta + ' más'
              : this.dataset.textoBoton || 'Agregar mi pack';
          }
        }

        onClick(ev) {
          var chip = ev.target.closest('[data-filtro]');
          if (chip) {
            this.filtro = chip.getAttribute('data-filtro');
            this.pintarChips();
            this.pintarPiezas();
            return;
          }
          var mas = ev.target.closest('[data-mas]');
          var menos = ev.target.closest('[data-menos]');
          var dec = ev.target.closest('[data-decant]');
          if (mas && !mas.disabled) {
            var id = mas.getAttribute('data-mas');
            if (this.totalPiezas() < this.piezas) this.elegidas[id] = (this.elegidas[id] || 0) + 1;
          } else if (menos) {
            var id2 = menos.getAttribute('data-menos');
            this.elegidas[id2] = (this.elegidas[id2] || 0) - 1;
            if (this.elegidas[id2] <= 0) delete this.elegidas[id2];
            if (this.totalPiezas() < this.piezas) this.decants = {};
          } else if (dec && !dec.disabled) {
            var id3 = dec.getAttribute('data-decant');
            if (this.decants[id3]) delete this.decants[id3];
            else if (this.totalDecants() < this.decantsX) this.decants[id3] = 1;
          } else if (ev.target.closest('[data-agregar-pack]')) {
            this.agregar(ev.target.closest('[data-agregar-pack]'));
            return;
          } else {
            return;
          }
          this.pintarPiezas();
          this.pintarDecants();
          this.pintarBarra();
          if (mas && this.totalPiezas() === this.piezas) {
            var paso = this.querySelector('[data-paso-decants]');
            if (paso && !paso.hidden) paso.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }

        async agregar(btn) {
          if (btn.disabled) return;
          var items = [];
          for (var k in this.elegidas) items.push({ id: Number(k), quantity: this.elegidas[k] });
          for (var j in this.decants) items.push({ id: Number(j), quantity: this.decants[j] });
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          var r = await post(URL_ADD, { items: items });
          btn.removeAttribute('aria-busy');
          if (!r || r.status) {
            btn.disabled = false;
            var err = this.querySelector('[data-error]');
            if (err) {
              err.hidden = false;
              err.textContent = (r && (r.description || r.message)) || 'No se pudo agregar. Intenta de nuevo.';
            }
            return;
          }
          this.elegidas = {};
          this.decants = {};
          this.pintarPiezas();
          this.pintarDecants();
          this.pintarBarra();
          var cart = await json(URL_CART);
          refrescar(cart, true);
        }
      }
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ajustar);
  else ajustar();
})();
